<template>
  <div class="ef-inner-row ef-edit">
    <div class="ef-feature">
      <div class="ef-row-inner-col ef-label edit-col">{{ item.name }}</div>
      <div class="ef-row-inner-col edit-col ">
        <div @click="isEditLocal = !isEditLocal" class="al-button blue-button">{{ isEditLocal ? 'Cancel' : 'Edit' }}</div>
      </div>
      <div v-if="isEditLocal" class="ef-row">
        <h2>Edit Feature</h2>

        <div class="ef-inner-row">
          <div class="ef-row-inner-col ef-label">Feature Name</div>
          <div class="ef-row-inner-col">
            <input class="ef-input" v-model="name" name="Name" v-validate="'required'" type="text" placeholder="Enter Name Here...">
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
        </div>
        <div class="ef-inner-row">
          <div class="ef-row-inner-col ef-label">Feature Slug</div>
          <div class="ef-row-inner-col">
            <input class="ef-input" v-model="slug" name="Slug" v-validate="'required'" type="text" placeholder="Enter Url Slug Here...">
            <span class="text-danger text-sm" v-show="errors.has('Slug')">{{ errors.first('Slug') }}</span>
          </div>
        </div>
        <div class="ef-inner-row">
          <div class="ef-row-inner-col ef-label">Feature Price</div>
          <div class="ef-row-inner-col">
            <input class="ef-input" v-model="price" type="number" min="1" step="any" name="Price" v-validate="'required'" placeholder="Enter Price Here...">
            <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
          </div>
        </div>
        <div class="ef-inner-row ef-single-row">
          <div class="ef-row-inner-col ef-label">Renewal Frequency</div>
          <div class="ef-row-inner-col ">
            <v-select name="user_group"
                      class="ef-input border-none"
                      v-model="freq"
                      :options="freq_options" :clearable="false"></v-select>
          </div>
        </div>
        <div class="ef-inner-row ef-single-row">
          <div class="ef-row-inner-col ef-label">Feature Description</div>
          <div class="ef-row-inner-col ">
            <textarea class="ef-input ef-textarea"  name="Description" v-model="description" placeholder="Enter description here..."></textarea>
          </div>
        </div>
        <div class="ef-inner-row">
          <div class="ef-row-inner-col"><div @click="deleteService" class="al-button inactive mr-2">Delete</div></div>
          <div class="ef-row-inner-col"><div @click="updateService" class="al-button ml-2">Save Changes</div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
export default {
  props: {
    item: {
      type: Object
    },
    updated: {
      type: Function
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    canceled: {
      type: Function
    }
  },
  components: {
    vSelect
  },
  name: 'CreateBundle',
  data () {
    return {
      name: '',
      slug: '',
      refresh: false,
      description: '',
      isEditLocal: false,
      price: 0,
      freq: {label: 'Monthly', value: 'monthly'},
      freq_options: [
        {label: 'Daily', value: 'daily'},
        {label: 'Weekly', value:'weekly'},
        {label: 'Monthly', value:'monthly'},
        {label: 'Yearly', value:'yearly'},
        {label: 'One time', value:'onetime'}
      ]
    }
  },
  methods: {
    setValues () {
      const { name, price, description, slug, freq } = JSON.parse(JSON.stringify(this.item))
      this.name = name
      this.price = price / 100
      this.description = description
      this.slug = slug
      this.freq = this.freq_options.filter(freq_ => freq_.value === freq)[0]
      this.isEditLocal = this.isEdit
      console.log('is edit', this.isEditLocal, this.isEdit)
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteService () {
      this.openConfirm(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading()

            this.$store.dispatch('deleteService', this.item._id)
              .then(response => {
                console.log('response', response)
                this.updated()
                setTimeout(() => {
                  this.initValues()
                  this.errors.clean()
                }, 500)
                this.$vs.loading.close()
              })
              .catch(err => {
                console.error(err)
              })

          }
        })
      }, () => {})
    },
    updateService () {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$vs.loading()
          const payload = {
            _id: this.item._id,
            name: this.name,
            slug: this.slug,
            description: this.description,
            price: Number.parseFloat(this.price) * 100,
            freq: this.freq.value
          }
          this.$store.dispatch('patchService', payload)
            .then(response => {
              console.log('response', response)
              this.updated(true, response.data.data)
              this.$vs.loading.close()
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    }
  },
  mounted () {
    this.setValues()
  }
}
</script>

<style scoped>

</style>
